module.exports = __webpack_public_path__ + "img/1578810619.616e6aae.jpg";